/* HZ 2026-09-14: moved out of snippets/hz-social-proof-banner.liquid into this deferred asset file.
   Same code; it used to be inlined into every page (and, for the quick-add,
   once per product card) and blocked HTML parsing while it evaluated. */
  (function() {
    var msgs = document.querySelectorAll('#hzSpTrack .hz-sp-msg');
    if (!msgs.length) return;
    var current = 0;
    var total = msgs.length;
    var interval = 4000;

    setInterval(function() {
      msgs[current].classList.remove('hz-sp-active');
      current = (current + 1) % total;
      msgs[current].classList.add('hz-sp-active');
    }, interval);

    /* Hide banner when Dawn menu drawer is open */
    var banner = document.querySelector('.hz-sp-banner');
    if (banner) {
      var drawer = document.querySelector('header-drawer details');
      if (drawer) {
        var obs = new MutationObserver(function() {
          banner.style.display = drawer.hasAttribute('open') ? 'none' : '';
        });
        obs.observe(drawer, { attributes: true, attributeFilter: ['open'] });
      }
    }
  })();
